import { useState } from 'react'
import { InsuranceIcon } from 'src/components/Icons/InsuranceIcon'
import { formatterPrice } from 'src/utils/formatterPrice'

import ModalLearnMoreBikeInsurance from './ModalLearnMoreBikeInsurance/ModalLearnMoreBikeInsurance'
import { useProductPageContext } from '../../../contexts'
import { useInsurancePrice } from './hooks/useInsurancePrice'

interface CmsSections {
  id: string
  name: string
  data: Record<string, unknown>
}

type LearnMoreBikeInsuranceProps = {
  cmsData?: {
    name: string
    sections?: CmsSections[]
  }
}

function LearnMoreBikeInsurance({ cmsData }: LearnMoreBikeInsuranceProps) {
  const [open, setOpen] = useState(false)
  const { product, currentSku } = useProductPageContext()

  // Só exibe se for página de bicicleta
  const isBike = product?.categories?.find(
    (cat: string) => cat === '/Equipamentos/Bicicletas/'
  )

  const isSoldByDecathlon = product?.sellerInfo?.id === '1'

  const skuBikePrice = currentSku?.sellerDefault?.sellerOffer?.price ?? 0

  // Busca o preço do seguro
  const { insurancePrice } = useInsurancePrice(skuBikePrice, !!isBike)

  if (!isBike || !isSoldByDecathlon) {
    return null
  }

  // Se não houver seguro disponível, mostra apenas a mensagem
  if (!insurancePrice) {
    return (
      <div className="w-full bg-[#F5F4F5] mt-6 p-6 hidden sm:block rounded">
        <p className="text-sm text-[#101010] text-center font-bold">
          Não há seguros disponíveis para o valor da sua bike.
        </p>
      </div>
    )
  }

  return (
    <div className="w-full bg-[#F5F4F5] mt-6 p-6 hidden sm:flex items-start justify-between rounded">
      <div className="flex items-start gap-3 w-3/4">
        <div className="mt-1">
          <InsuranceIcon />
        </div>
        <div>
          <h3 className="text-base font-medium text-[#101010]">
            Adicione Seguro Bike | 12 meses
          </h3>
          <p className="text-xs text-[#101010] mt-1">
            A partir de {formatterPrice(insurancePrice)} à vista <br />
            Consulte as opções de parcelamento
          </p>
        </div>
      </div>
      <button
        className="text-base text-[#101010] underline w-1/4 font-medium"
        onClick={() => setOpen(true)}
      >
        Saiba mais
      </button>
      <ModalLearnMoreBikeInsurance
        isOpen={open}
        onDismiss={() => setOpen(false)}
        cmsData={cmsData}
      />
    </div>
  )
}

export default LearnMoreBikeInsurance
